module.exports = __webpack_public_path__ + "static/partial03-d51dca1eae76c4b3b15624a8b1649d8e.jpg";